module.exports = "dist/d198bc5eeb0e6d81608e9951672c9dc6.eot";